// src/services/settingsService.js
import api from 'services/api';

export const settingsService = {
  // Get all settings (admin only)
  getSettings: async () => {
    const response = await api.get('/settings');
    return response.data;
  },

  // Get a specific setting by key
  getSetting: async (key) => {
    const response = await api.get(`/settings/${key}`);
    return response.data;
  },

  // Update a setting (admin only)
  updateSetting: async (key, value, description = null) => {
    const response = await api.put(`/settings/${key}`, { value, description });
    return response.data;
  },

  // Get currency rates (accessible to all authenticated users)
  getCurrencyRates: async () => {
    const response = await api.get('/settings/currency-rates');
    return response.data;
  },

  // Get default currency (accessible to all authenticated users)
  getDefaultCurrency: async () => {
    const response = await api.get('/settings/default-currency');
    return response.data;
  },

  // Update default currency (admin only)
  updateDefaultCurrency: async (currency) => {
    const response = await api.put('/settings/default-currency/update', { currency });
    return response.data;
  },

  // Helper: Convert amount from one currency to another
  // Rates are stored relative to default currency
  convertCurrency: (amount, fromCurrency, toCurrency, rates) => {
    if (fromCurrency === toCurrency) return amount;

    // Direct conversion using rates relative to default currency
    const fromRate = rates[fromCurrency] || 1;
    const toRate = rates[toCurrency] || 1;

    const convertedAmount = amount * (toRate / fromRate);

    return convertedAmount;
  },

  // Get vendor's preferred currency (vendor and opex_vendor only)
  getVendorCurrency: async () => {
    const response = await api.get('/vendor/currency');
    return response.data;
  },

  // Update vendor's preferred currency (vendor and opex_vendor only)
  updateVendorCurrency: async (currency) => {
    const response = await api.put('/vendor/currency', { preferred_currency: currency });
    return response.data;
  },

  // Refresh currency rates from external API (admin only)
  refreshCurrencyRates: async () => {
    const response = await api.post('/settings/currency-rates/refresh');
    return response.data;
  }
};

export default settingsService;
